/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Collector Versions";
const frontMatter = {};
import {Icon} from '@/components';
import {mdiHelpCircle} from '@mdi/js';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return <_components.p>{"Chronosphere supports Chronosphere Collector versions for a year from release. You\ncan find a full list of versions and release dates in the Collector release notes\nlocated in the Chronosphere Observability Platform. To view the release notes, in the\nnavigation menu select\n"}<_components.strong><Icon path={mdiHelpCircle} />{" Help "}<span aria-label="and then">{">"}</span>{" Release notes"}</_components.strong>{",\nand then click the "}<_components.strong>{"Collector"}</_components.strong>{" tab."}</_components.p>;
}

export default MDXLayout